import { useEffect, useState } from 'react'

interface Size {
  width: number
  height: number
}
export function useRefSize(ref: React.RefObject<HTMLElement>): Size {
  const [size, setSize] = useState<Size>({ width: 0, height: 0 })

  useEffect(() => {
    if (!ref.current) return

    const updateSize = () => {
      const element = ref.current
      if (!element) return

      const { width, height } = element.getBoundingClientRect()
      setSize((prevSize) => {
        if (prevSize.width === width && prevSize.height === height) {
          return prevSize
        }
        return { width, height }
      })
    }

    updateSize()

    const resizeObserver = new ResizeObserver(() => {
      window.requestAnimationFrame(updateSize)
    })

    resizeObserver.observe(ref.current)

    return () => resizeObserver.disconnect()
  }, [ref])
  return size
}
